export const USER_TYPES = {
    Retailer: 'Retailer',
    Farmer: 'Farmer',
    Processor: 'Processor'
}
